export const createStringFromTemplate = (template: string, variables: {[key: string]: string}) => {
  return template.replace(new RegExp("{([^{]+)}", "g"), function (
    _unused,
    varName
  ) {
    return variables[varName];
  });
}